
function holdingNameIsTooLong(holdingNameElement) {
    const textBounds = holdingNameElement.getBoundingClientRect();
    const parent = holdingNameElement.closest('[data-holdings-container]');
    const sibling = parent.querySelector('[data-holdings-number]');
    const siblingBounds = sibling.getBoundingClientRect();

    // Check if text flows over onto the sibling
    return textBounds.bottom > siblingBounds.top;
}

function reduceFontSize(el) {
    const currentFontSize = parseFloat(getComputedStyle(el).fontSize);
    el.style.fontSize = (currentFontSize - 0.5) + 'px';
}

function adjustHoldingNameSizesIfTooLarge() {
    const holdingNames = document.querySelectorAll('[data-holdings-name]');

    holdingNames.forEach((el) => {
        let retries = 0;
        while (holdingNameIsTooLong(el) && retries < 20) {
            reduceFontSize(el);
            retries++;
        }
    });
}
adjustHoldingNameSizesIfTooLarge();